import React from 'react';
import PropTypes from 'prop-types';

import FinanceMethodPage from 'payment-calculator-v25/components/PaymentCalculatorDetails/components/FinanceMethodPage/FinanceMethodPage.jsx';
import CashMethodPage from 'payment-calculator-v25/components/PaymentCalculatorDetails/components/CashMethodPage/CashMethodPage.jsx';

const PurchaseMethodsTabControlContainer = ({ cashPurchaseSelected, config, displayCreditRate }) => {
    return (
        <div className="showroom-calculator-new-inner">
            {cashPurchaseSelected ? (
                <CashMethodPage config={config} />
            ) : (
                <FinanceMethodPage config={config} displayCreditRate={displayCreditRate} />
            )}
        </div>
    );
};

PurchaseMethodsTabControlContainer.defaultProps = {
    displayCreditRate: false,
};
PurchaseMethodsTabControlContainer.propTypes = {
    cashPurchaseSelected: PropTypes.bool.isRequired,
    displayCreditRate: PropTypes.bool,
};

PurchaseMethodsTabControlContainer.displayName = 'PurchaseMethodsTabControlContainer';

export default PurchaseMethodsTabControlContainer;
